// extracted by mini-css-extract-plugin
export default {"scoreboard":"Scoreboard_scoreboard__R5aA+"};